module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-app-bar-title', {
    staticClass: "centered-title"
  }, [_vm._v(_vm._s(_vm.$t("GroupedBarChart.accumulatedHours")) + " " + _vm._s(_vm.pageNumber))]), _vm._v(" "), (_vm.loading) ? _c('v-progress-circular', {
    staticClass: "loading-icon",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "3",
      "color": "#0098E1"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('apexchart', {
    staticClass: "grouped-bar-content",
    attrs: {
      "type": "bar",
      "height": "410px",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93d58a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/GroupedBarChart.vue
// module id = 1736
// module chunks = 0